import _classCallCheck from "/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf.js";
import _inherits from "/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/inherits.js";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module media-embed/mediaembedcommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import { findOptimalInsertionPosition } from '@ckeditor/ckeditor5-widget/src/utils';
import { getSelectedMediaModelWidget, insertMedia } from "./utils";
/**
 * The insert media command.
 *
 * The command is registered by the {@link module:media-embed/mediaembedediting~MediaEmbedEditing} as `'mediaEmbed'`.
 *
 * To insert media at the current selection, execute the command and specify the URL:
 *
 *		editor.execute( 'mediaEmbed', 'http://url.to.the/media' );
 *
 * @extends module:core/command~Command
 */

var MediaEmbedCommand =
/*#__PURE__*/
function (_Command) {
  _inherits(MediaEmbedCommand, _Command);

  function MediaEmbedCommand() {
    _classCallCheck(this, MediaEmbedCommand);

    return _possibleConstructorReturn(this, _getPrototypeOf(MediaEmbedCommand).apply(this, arguments));
  }

  _createClass(MediaEmbedCommand, [{
    key: "refresh",

    /**
     * @inheritDoc
     */
    value: function refresh() {
      var model = this.editor.model;
      var selection = model.document.selection;
      var schema = model.schema;
      var position = selection.getFirstPosition();
      var selectedMedia = getSelectedMediaModelWidget(selection);
      var parent = position.parent;

      if (parent != parent.root) {
        parent = parent.parent;
      }

      this.value = selectedMedia ? selectedMedia.getAttribute('url') : null;
      this.isEnabled = schema.checkChild(parent, 'media');
    }
    /**
     * Executes the command, which either:
     *
     * * updates the URL of the selected media,
     * * inserts the new media into the editor and puts the selection around it.
     *
     * @fires execute
     * @param {String} url The URL of the media.
     */

  }, {
    key: "execute",
    value: function execute(url) {
      var model = this.editor.model;
      var selection = model.document.selection;
      var selectedMedia = getSelectedMediaModelWidget(selection);

      if (selectedMedia) {
        model.change(function (writer) {
          writer.setAttribute('url', url, selectedMedia);
        });
      } else {
        var insertPosition = findOptimalInsertionPosition(selection, model);
        insertMedia(model, url, insertPosition);
      }
    }
  }]);

  return MediaEmbedCommand;
}(Command);

export { MediaEmbedCommand as default };